import * as React from 'react'

import { classList } from 'react-classlist-helper'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/client/src/shared/components/shadcn-ui/popover'

interface IProps {
  trigger: React.ReactNode
  children: React.ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  align?: 'start' | 'center' | 'end'
  sideOffset?: number
  className?: string
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

const WorkflowFieldRestrictionPanel: React.FC<IProps> = ({
  trigger,
  children,
  side = 'bottom',
  align = 'start',
  sideOffset = 4,
  className,
  open,
  onOpenChange,
}) => {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger nativeButton={false} render={<div />}>
        {trigger}
      </PopoverTrigger>
      <PopoverContent
        side={side}
        align={align}
        sideOffset={sideOffset}
        className={classList({
          'tw:w-auto tw:gap-0 tw:p-0 tw:overflow-hidden': true,
          [className]: !!className,
        })}
      >
        {children}
      </PopoverContent>
    </Popover>
  )
}

export default WorkflowFieldRestrictionPanel
